var EPK = EPK || {};
EPK.common = EPK.common || {};
EPK.Okusuritecho = EPK.Okusuritecho || {};

$(function(){
	EPK.Okusuritecho.initialize();
});

EPK.Okusuritecho.initialize = function() {
	EPK.Okusuritecho.initScroll();
	EPK.Okusuritecho.initBrandScrollBox();
	EPK.Okusuritecho.initFaq();
};

EPK.Okusuritecho.initScroll = function(){
	// ページ内リンク、#非表示。スムーズスクロール
	var enable_ids = [ 'howto', 'faq-contents-top' ];

	for( var i = 0; i < enable_ids.length; i ++ ) {
		$('a[href^="#' + enable_ids[ i ] + '"]').click(function(){
			var speed = 800;
			var href= $(this).attr("href");
			var target = $(href == "#" || href == "" ? 'html' : href);
			var position = target.offset().top;
			$("html, body").animate({scrollTop:position}, speed, "swing");
			return false;
		});
	}
};

EPK.Okusuritecho.initBrandScrollBox = function() {

	if ($('#is_pc').length > 0 && $('#is_pc').val() == 1) {
		$(window).on("load",function(){
			$.mCustomScrollbar.defaults.scrollButtons.enable=true; // enable scrolling buttons by default
			$("#content-dtk").mCustomScrollbar({theme:"dark-thick"});
		});
	} else {
		$("#brand-slides").swiper({
			scrollbarHide: true,
			slidesPerView: 1,
			centeredSlides: false,
			spaceBetween: 15,
			grabCursor: true,
			preloadImages: true,
			paginationClickable: true,
			pagination: ".swiper-pagination",
			nextButton: ".swiper-button-next",
			prevButton: ".swiper-button-prev",
			loop: true
		});
	}
};


EPK.Okusuritecho.initFaq = function() {
	$('.faq-left li a').on('click', function() {
		$('.tab_item').removeClass("is-active-item");
		$($(this).attr("href")).addClass("is-active-item");

		$('.faq-left li a').removeClass('is-active-btn');
		$(this).addClass('is-active-btn');
		return false;
	});
};